import React from 'react';
import { BoxIcon } from 'lucide-react';
type StatCardProps = {
  title: string;
  value: string | number;
  icon: BoxIcon;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  colorClass?: string;
};
export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  icon: Icon,
  trend,
  colorClass = 'text-brand-primary'
}) => {
  return <div className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm" data-id="element-389">
      <div className="flex items-center justify-between mb-4" data-id="element-390">
        <h3 className="text-sm font-medium text-brand-text-light" data-id="element-391">{title}</h3>
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center bg-gray-50 ${colorClass}`} data-id="element-392">
          <Icon size={20} data-id="element-393" />
        </div>
      </div>
      <div className="flex items-baseline gap-2" data-id="element-394">
        <p className="text-2xl font-bold text-brand-text-dark" data-id="element-395">{value}</p>
        {trend && <span className={`text-xs font-medium ${trend.isPositive ? 'text-brand-primary' : 'text-brand-error'}`} data-id="element-396">
            {trend.isPositive ? '+' : '-'}
            {Math.abs(trend.value)}%
          </span>}
      </div>
    </div>;
};